import {
  DEFAULT_DONATION_CURRENCY_CODE,
  DONATION_CURRENCIES,
  DONATION_CURRENCY_BY_COUNTRY_CODE
} from '@/generated/donationCurrencies.js'

export {
  DEFAULT_DONATION_CURRENCY_CODE,
  DONATION_CURRENCIES,
  DONATION_CURRENCY_BY_COUNTRY_CODE
}

export const DONATION_CURRENCY_CODES = DONATION_CURRENCIES.map(currency => currency.id)

export function normalizeDonationCurrencyCode(currencyCode) {
  if (!currencyCode) {
    return DEFAULT_DONATION_CURRENCY_CODE
  }

  return String(currencyCode).toUpperCase()
}

export function donationCurrencyCodeForCountry(countryCode) {
  if (!countryCode) {
    return DEFAULT_DONATION_CURRENCY_CODE
  }

  return DONATION_CURRENCY_BY_COUNTRY_CODE[String(countryCode).toUpperCase()] || DEFAULT_DONATION_CURRENCY_CODE
}

export function donationCurrencyForCode(currencyCode) {
  const normalizedCurrencyCode = normalizeDonationCurrencyCode(currencyCode)

  return DONATION_CURRENCIES.find(currency => currency.id === normalizedCurrencyCode) || DONATION_CURRENCIES.find(currency => currency.id === DEFAULT_DONATION_CURRENCY_CODE)
}

export function donationCurrencySymbol(currencyCode) {
  return donationCurrencyForCode(currencyCode).symbol
}

export function donationCurrencyLocale(currencyCode) {
  return donationCurrencyForCode(currencyCode).locale
}

export function donationCurrencyStripeFixedFee(currencyCode) {
  return donationCurrencyForCode(currencyCode).stripeFixedFee
}

export function formatDonationAmount(value, currencyCode = DEFAULT_DONATION_CURRENCY_CODE, options = {}) {
  const currency = donationCurrencyForCode(currencyCode)
  const amount = Number(value || 0)
  const minimumFractionDigits = options.minimumFractionDigits ?? (options.maximumFractionDigits ?? 2)
  const maximumFractionDigits = options.maximumFractionDigits ?? minimumFractionDigits

  return new Intl.NumberFormat(currency.locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount)
}

export function formatDonationMoney(value, currencyCode = DEFAULT_DONATION_CURRENCY_CODE, options = {}) {
  const currency = donationCurrencyForCode(currencyCode)

  return `${currency.symbol}${formatDonationAmount(value, currency.id, options)}`
}
